import Catalog from "./Catalog";

export default function Categories() {
  return <Catalog initialTab="categories" />;
}
